import React from 'react';
import TableReport from "../../../common/table/table";
import MessageEmptyData from "../../../common/messageEmptyData";
import {isEmpty} from "lodash"
import {tableColumns} from "./tableColumns";

/**
 * Body report component for daily summary report
 * @param prop
 * @returns {JSX.Element|null}
 * @constructor
 */
const DailyReportSummaryBody = (prop) => {
    const {reportFilters, tableData} = prop;

    if (!reportFilters.isSubmitted) {
        return null;
    }

    if (isEmpty(tableData)) {
        return <MessageEmptyData/>;
    }

    return (
        <div className="container-fluid">
            <TableReport
                columns={tableColumns}
                data={tableData}
                exportOptions={{pdf: false, xlsx: true, csv: true}}
                getExportFileName={() => 'daily_report_summary'}
                withGlobalSearch={true}
                scrollable={true}
            />
        </div>
    );
}

export default DailyReportSummaryBody;
